import { render, staticRenderFns } from "./LandingPageFaq.vue?vue&type=template&id=36fce55c"
import script from "./LandingPageFaq.vue?vue&type=script&lang=js"
export * from "./LandingPageFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports